namespace SorAraBul.Web.Services.HasoApi {
    export interface HasoErrorCodeSyncResponse extends Serenity.ServiceResponse {
        Total?: number;
        Inserted?: number;
        Updated?: number;
        Skipped?: number;
    }
}
